import React from "react";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { PREVIEW_MODE, PAYMENTS_ENABLED, PRODUCT_NAME } from "../../data/siteConfig";
import { getCheckoutHref } from "../../utils/checkout";
import { trackPixelEvent } from "../../utils/metaPixel";
export function CheckoutAction() {
  const href = getCheckoutHref();
  if (PREVIEW_MODE || !href) {
    return <button type="button" disabled className="mt-8 flex min-h-14 w-full cursor-not-allowed items-center justify-center gap-2.5 rounded-[10px] border border-navy/15 bg-navy/[0.07] px-3 py-3 font-display text-[18px] font-bold uppercase text-navy/75" data-id="element-101" data-mp="141du31fcrgsj">
        <LockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-102" data-mp="u4htdhvp3yyj" />
        Checkout not open
      </button>;
  }
  return <>
      <a href={href} aria-describedby="checkout-note" onClick={() => trackPixelEvent("InitiateCheckout", {
      content_name: PRODUCT_NAME,
      value: 27,
      currency: "USD",
      num_items: 1
    })} className="btn-primary mt-8 w-full justify-center" data-id="element-103" data-mp="z447dtjclj8e">
        View checkout
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-104" data-mp="26av13jsvsnhn" />
      </a>
      <p id="checkout-note" className="mt-4 text-sm leading-relaxed text-navy/75" data-id="element-105" data-mp="2k1hq2k8uaz0j">
        {PAYMENTS_ENABLED ? "Digital teaching resources only. Review the order details and available payment methods at checkout." : "The checkout is linked, but payment methods are still being configured. A completed purchase is not yet available."}
      </p>
    </>;
}